import axios from 'axios'

const axiosInstance = axios.create()

if (process.env.NODE_ENV === 'development') {
  axiosInstance.defaults.baseURL = 'http://localhost:5000'
}

axiosInstance.interceptors.response.use(
  response => response.data,
)

export default {
  signIn(data) {
    return axiosInstance.post('/api/admin/auth', data)
  },

  issueAccessToken(refreshToken) {
    return axiosInstance.post('/api/auth/accessToken', {
      refreshToken,
    })
  },
}
